import {
  Debounce,
  DisruptorSuggestionItem,
  DisruptorsProvider,
  Editor,
  MentionTypes,
  StandardInlineToolbar,
  StandardMentions,
  StandardMentionsPopover,
  StandardSideToolbar,
} from "../..";
import React, { Fragment } from "react";

import PropTypes from "prop-types";

/**
 * @type {Function}
 */
const noop = () => {};

export default function DisruptorsEditor({ children, ...props }) {
  return (
    <Editor {...props}>
      {({ editorKey, editorState, focus, focusEditor, onChange }) => (
        <>
          <StandardSideToolbar
            focus={focus}
            editorKey={editorKey}
            editorState={editorState}
            focusEditor={focusEditor}
            onChange={onChange}
          />

          <StandardInlineToolbar editorState={editorState} focusEditor={focusEditor} onChange={onChange} />

          <StandardMentions editorState={editorState} onChange={onChange}>
            {({ query, suggestions, selectedIndex, onChange, acceptSuggestion }) => (
              <>
                {suggestions.length > 0 && (
                  <StandardMentionsPopover>
                    {suggestions
                      .map((suggestion, index) => {
                        const isSelected = selectedIndex === index;
                        const type = suggestion.getMentionType();

                        if (type === MentionTypes.DISRUPTOR) {
                          return (
                            <DisruptorSuggestionItem
                              // eslint-disable-next-line
                              key={index}
                              isSelected={isSelected}
                              suggestion={suggestion}
                              acceptSuggestion={acceptSuggestion}
                            />
                          );
                        }

                        return null;
                      })
                      .filter(Boolean)}
                  </StandardMentionsPopover>
                )}

                <Debounce ms={100}>
                  <DisruptorsProvider query={query} onChange={onChange} />
                </Debounce>
              </>
            )}
          </StandardMentions>

          {children({
            editorKey,
            editorState,
            focus,
            focusEditor,
            onChange,
          })}
        </>
      )}
    </Editor>
  );
}

DisruptorsEditor.propTypes = {
  children: PropTypes.func,
};

DisruptorsEditor.defaultProps = {
  children: noop,
};
